// import { Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { useForm } from "react-hook-form";
// import { FaRegClock } from "react-icons/fa6";
// import WSTimePicker from "../../../Components/WSTimePicker/WSTimePicker";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import { GiDiamonds } from "react-icons/gi";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import {
//   getLocalValue,
//   LoacalVariables,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SlotDrawer from "./Slote";

// interface ScheduleFormData {
//   labId: string;
//   durationInMinutes: string;
//   startTime: string;
//   endTime: string;
//   date: string;
//   isAvailable: boolean;
// }

// export const ScheduleManagement: React.FC<any> = React.memo((props) => {
//   const methods = useForm<ScheduleFormData>({
//     defaultValues: {
//       labId: "",
//       durationInMinutes: "",
//       startTime: "",
//       endTime: "",
//       date: "",
//       isAvailable: false,
//     },
//   });

//   const { control, reset, setValue, handleSubmit } = methods;
//   const [labId, setLabId] = useState<string>("");
//   const [open, setOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();

//   // ✅ FIXED: Missing functions added
//   const handleCancel = () => {
//     reset();
//     setOpen(false);
//     setFormComponent(null);
//   };

//   const refetchSlots = () => {
//     console.log("🔄 Slots refetched - Add your refresh logic here");
//     reset();
//     setOpen(false);
//     setFormComponent(null);
//   };

//   useEffect(() => {
//     updateMainHeader("Schedules");
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([{ Schedules: "/lab-schedule" }]);

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     const finalLabId = userId || "";
//     setLabId(finalLabId);
//     setValue("labId", finalLabId);
//   }, [setValue]);

//   const handleClick = () => {
//   setFormComponent(
//     <SlotDrawer 
//       id="slotAdd"  // ✅ CHANGED: Must match SwipeableDrawerForm id="slotAdd"
//       control={control} 
//       reset={reset} 
//       setValue={setValue}
//       onCancel={handleCancel}
//       onSuccess={refetchSlots}
//     />
//   );
//   setOpen(true);
// };

//   return (
//     <>
//       <Grid container>
//         <Grid item xs={12}>
//           <Paper
//             elevation={0}
//             style={{
//               paddingLeft: 20,
//               paddingRight: 20,
//               marginTop: 0,
//               paddingBottom: 25,
//               borderRadius: "8px",
//             }}
//           >
//             <Grid container alignItems="center" justifyContent="space-between">
//               <Grid item xs>
//                 <Typography variant="h6" fontWeight={600}>
//                   Schedule Management
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Schedule and manage patient appointments while monitoring
//                   availability and appointment status.
//                 </Typography>
//               </Grid>
//               <Grid item>
//                 <WSButton
//                   id="btnAddSlot"
//                   label="Add Slot"
//                   startIcon={<WSIcons.AddIcon />}
//                   onClick={handleClick}
//                   sx={{
//                     borderRadius: "999px",
//                     backgroundColor: "#098963!important",
//                     textTransform: "none",
//                     fontWeight: 500,
//                     height: "35px!important",
//                     fontSize: "0.875rem!important",
//                     px: 3,
//                     "&:hover": {
//                       backgroundColor: "#087654!important",
//                     },
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem" }}>
//                     <CalendarTodayIcon /> Working Hours
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTimePicker
//                     label="Starting"
//                     name="startTime"
//                     id="startTime"
//                     control={control}
//                     rules={{ required: "Required" }}
//                     timeSize="small"
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTimePicker
//                     label="Ending"
//                     name="ending"
//                     id="ending"
//                     control={control}
//                     rules={{ required: "Required" }}
//                     timeSize="small"
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem" }}>
//                     <FaRegClock /> Duration Per Appointment
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     label="Minutes"
//                     id="minutes"
//                     name="minutes"
//                     control={control}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem" }}>
//                     <FaRegClock /> Slot Availability
//                   </Typography>
//                 </Grid>
                // <Grid item xs={12} sm={6}>
                //   <WSDateField
                //     id="startDate"
                //     name="startDate"
                //     label="Start Date"
                //     dateFormat="DD-MM-YYYY"
                //     control={control}
                //     defaultValue={null}
                //     rules={{ required: false }}
                //   />
                // </Grid>
                // <Grid item xs={12} sm={6}>
                //   <WSDateField
                //     id="endDate"
                //     name="endDate"
                //     label="End Date"
                //     dateFormat="DD-MM-YYYY"
                //     control={control}
                //     defaultValue={null}
                //     rules={{ required: false }}
                //   />
                // </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//               <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
//                 <GiDiamonds />
//                 Morning
//               </Typography>
//             </Paper>
//           </Grid>
//           <Grid item xs={12}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//               <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
//                 <GiDiamonds />
//                 After noon
//               </Typography>
//             </Paper>
//           </Grid>
//           <Grid item xs={12}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//               <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
//                 <GiDiamonds />
//                 Evening
//               </Typography>
//             </Paper>
//           </Grid>
//         </Grid>

//         <SwipeableDrawerForm
//           anchor="right"
//           title="Add Slot"
//           openForm={open}
//           isEdit={false}
//           id="slotAdd"
//           formComponent={formComponent}
//           onClose={() => {
//             reset();
//             setOpen(false);
//             setFormComponent(null);
//           }}
//         />
//       </Grid>
//     </>
//   );
// });







// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { useForm } from "react-hook-form";
// import { FaRegClock } from "react-icons/fa6";
// import WSTimePicker from "../../../Components/WSTimePicker/WSTimePicker";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import { GiDiamonds } from "react-icons/gi";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import {
//   getLocalValue,
//   LoacalVariables,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SlotDrawer from "./Slote";
// import http from "../../../commonFunctions/httpClient";

// // ✅ CORRECTED: ACTUAL API RESPONSE STRUCTURE
// interface LabSlot {
//   id: string;
//   labId: string;
//   lab: any;
//   sheduledDate: string;
//   durationInMinutes: number;
//   startTime: string;
//   endTime: string;
//   isAvailable: boolean;
// }

// interface ScheduleFormData {
//   labId: string;
//   durationInMinutes: string;
//   startTime: string;
//   endTime: string;
//   date: string;
//   isAvailable: boolean;
// }

// // ✅ FIXED: SlotDrawerProps - Remove labId prop
// interface SlotDrawerProps {
//   id: string;
//   control: any;
//   reset: any;
//   setValue: any;
//   onCancel: () => void;
//   onSuccess: () => void;
// }

// export const ScheduleManagement: React.FC<any> = React.memo((props) => {
//   const methods = useForm<ScheduleFormData>({
//     defaultValues: {
//       labId: "",
//       durationInMinutes: "",
//       startTime: "",
//       endTime: "",
//       date: "",
//       isAvailable: false,
//     },
//   });

//   const { control, reset, setValue } = methods;
//   const [labId, setLabId] = useState<string>("");
//   const [open, setOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [slots, setSlots] = useState<LabSlot[]>([]);
//   const [loading, setLoading] = useState(true);

//   const fetchLabSlots = useCallback(async () => {
//     if (!labId) return;
    
//     setLoading(true);
//     try {
//       console.log("🔄 Fetching slots for labId:", labId);
//       const response: any = await http.get(`lab/LabSlot/lab/${labId}`);
      
//       console.log("📡 FULL API RESPONSE:", response);
      
//       const apiData: LabSlot[] = Array.isArray(response.data?.data) 
//         ? response.data.data 
//         : response.data || [];
      
//       console.log("📊 PROCESSED SLOTS:", apiData);
//       setSlots(apiData);
      
//       if (apiData.length > 0) {
//         const firstSlot = apiData[0];
//         setValue("startTime", firstSlot.startTime || "");
//         setValue("endTime", firstSlot.endTime || "");
//         setValue("durationInMinutes", firstSlot.durationInMinutes.toString());
//       }
//     } catch (error) {
//       console.error("❌ Failed to fetch lab slots:", error);
//       setSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [labId, setValue]);

//   const handleCancel = () => {
//     reset();
//     setOpen(false);
//     setFormComponent(null);
//   };

//   const refetchSlots = () => {
//     fetchLabSlots();
//     handleCancel();
//   };

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setLabId(userId || "");
//   }, []);

//   useEffect(() => {
//     if (labId) {
//       fetchLabSlots();
//     }
//   }, [labId, fetchLabSlots]);

//   useEffect(() => {
//     updateMainHeader("Schedules");
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([{ Schedules: "/lab-schedule" }]);

//   const handleClick = () => {
//     // ✅ FIXED: Removed labId prop - matches SlotDrawerProps
//     setFormComponent(
//       <SlotDrawer 
//         id="slotAdd"
//         control={control} 
//         reset={reset} 
//         setValue={setValue}
//         onCancel={handleCancel}
//         onSuccess={refetchSlots}
//       />
//     );
//     setOpen(true);
//   };

//   const getSlotsByPeriod = (period: 'morning' | 'afternoon' | 'evening') => {
//     return slots.filter(slot => {
//       if (!slot.startTime) return false;
//       const startHour = parseInt(slot.startTime.split(':')[0]);
//       if (period === 'morning') return startHour >= 6 && startHour < 12;
//       if (period === 'afternoon') return startHour >= 12 && startHour < 17;
//       return startHour >= 17;
//     });
//   };

//   const formatTime = (time: string) => {
//     if (!time) return "N/A";
//     const [hours, minutes] = time.split(':');
//     const hour = parseInt(hours);
//     const period = hour >= 12 ? 'PM' : 'AM';
//     const displayHour = hour % 12 || 12;
//     return `${displayHour}:${minutes} ${period}`;
//   };

//   const formatDate = (dateString: string) => {
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ height: '200px' }}>
//         <Typography>Loading schedule...</Typography>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container>
//         <Grid item xs={12}>
//           <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//             <Grid container alignItems="center" justifyContent="space-between">
//               <Grid item xs>
//                 <Typography variant="h6" fontWeight={600}>Schedule Management</Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Showing <strong>{slots.length}</strong> total slots
//                 </Typography>
                
//               </Grid>
              
//               <Grid item>
//                 <WSButton
//                   id="btnAddSlot"
//                   label="Add Slot"
//                   startIcon={<WSIcons.AddIcon />}
//                   onClick={handleClick}
//                   sx={{
//                     borderRadius: "999px",
//                     backgroundColor: "#098963!important",
//                     textTransform: "none",
//                     fontWeight: 500,
//                     height: "35px!important",
//                     fontSize: "0.875rem!important",
//                     px: 3,
//                     "&:hover": { backgroundColor: "#087654!important" },
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem" }}>
//                     <CalendarTodayIcon /> Working Hours
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTimePicker label="Starting" name="startTime" id="startTime" control={control} rules={{ required: "Required" }} timeSize="small" />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSTimePicker label="Ending" name="endTime" id="endTime" control={control} rules={{ required: "Required" }} timeSize="small" />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <Typography sx={{ fontSize: "1rem" }}>
//                     <FaRegClock /> Duration Per Appointment
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <WSTextField
//                     label="Minutes"
//                     id="durationInMinutes"
//                     name="durationInMinutes"
//                     control={control}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//                <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                     <Typography sx={{ fontSize: "1rem" }}>
//                 <FaRegClock /> Total Slots: {slots.length}
//               </Typography>
//               </Grid>
//                <Grid item xs={12} sm={6}>
//                   <WSDateField
//                     id="startDate"
//                     name="startDate"
//                     label="Start Date"
//                     dateFormat="DD-MM-YYYY"
//                     control={control}
//                     defaultValue={null}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <WSDateField
//                     id="endDate"
//                     name="endDate"
//                     label="End Date"
//                     dateFormat="DD-MM-YYYY"
//                     control={control}
//                     defaultValue={null}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//                 </Grid>
//             </Paper>
//           </Grid>
//         </Grid>

//         {/* ✅ FIXED: Inline styles only - no MUI sx mb prop */}
//        <Grid container spacing={2} mt={2}>
//   {(['morning', 'afternoon', 'evening'] as const).map((period) => {
//     const periodSlots = getSlotsByPeriod(period);

//     return (
//       <Grid item xs={12} key={period}>
//         <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//           <Typography
//             variant="subtitle1"
//             fontWeight={600}
//             sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
//           >
//             <GiDiamonds />
//             {period.charAt(0).toUpperCase() + period.slice(1)} Slots ({periodSlots.length})
//           </Typography>

//           {periodSlots.length === 0 ? (
//             <Typography variant="body2" color="text.secondary">
//               No {period} slots
//             </Typography>
//           ) : (

//  <Box
//               sx={{
//                 maxHeight: 260,          // 👈 height per section
//                 overflowY: "auto",       // 👈 vertical scroll
//                 pr: 1,                   // space for scrollbar
//               }}
//             >
//             <Grid container spacing={2}>
//               {periodSlots.map((slot, index) => (
//                 <Grid item xs={12} sm={6} md={3} key={slot.id || index}>
//                   <Paper
//                     sx={{
//                       p: 1.5,
//                       backgroundColor: "#f5f5f5",
//                       borderRadius: "6px",
//                       height: "100%",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         mb: 1,
//                       }}
//                     >
//                       <Typography variant="body2" fontWeight={500}>
//                         {formatDate(slot.sheduledDate)}
//                       </Typography>
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           color: slot.isAvailable ? "#4caf50" : "#f44336",
//                           fontWeight: 600,
//                         }}
//                       >
//                         {slot.isAvailable ? "Available" : "Unavailable"}
//                       </Typography>
//                     </Box>

//                     <Typography variant="body1" fontWeight={600}>
//                       {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
//                     </Typography>

//                     <Typography variant="caption" color="text.secondary">
//                       ({slot.durationInMinutes} min)
//                     </Typography>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//             </Box>
//           )}
//         </Paper>
//       </Grid>
//     );
//   })}
// </Grid>


//         <SwipeableDrawerForm
//           anchor="right"
//           title="Add Slot"
//           openForm={open}
//           isEdit={false}
//           id="slotAdd"
//           formComponent={formComponent}
//           onClose={handleCancel}
//         />
//       </Grid>
//     </>
//   );
// });






// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { useForm } from "react-hook-form";
// import { FaRegClock } from "react-icons/fa6";
// import WSTimePicker from "../../../Components/WSTimePicker/WSTimePicker";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import { GiDiamonds } from "react-icons/gi";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import {
//   getLocalValue,
//   LoacalVariables,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SlotDrawer from "./Slote";
// import http from "../../../commonFunctions/httpClient";

// interface LabSlot {
//   id: string;
//   labId: string;
//   lab: any;
//   sheduledDate: string;
//   durationInMinutes: number;
//   startTime: string;
//   endTime: string;
//   isAvailable: boolean;
// }

// interface ScheduleFormData {
//   labId: string;
//   durationInMinutes: string;
//   startTime: string;
//   endTime: string;
//   startDate: string;
//   endDate: string;
//   isAvailable: boolean;
// }

// export const ScheduleManagement: React.FC<any> = React.memo((props) => {
//   const methods = useForm<ScheduleFormData>({
//     defaultValues: {
//       labId: "",
//       durationInMinutes: "",
//       startTime: "",
//       endTime: "",
//       startDate: "",
//       endDate: "",
//       isAvailable: false,
//     },
//   });

//   const { control, reset, setValue, watch } = methods;
  
//   const watchedDuration = watch("durationInMinutes");
//   const watchedStartTime = watch("startTime");
//   const watchedEndTime = watch("endTime");
//   const watchedStartDate = watch("startDate");
//   const watchedEndDate = watch("endDate");

//   const [labId, setLabId] = useState<string>("");
//   const [open, setOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [allSlots, setAllSlots] = useState<LabSlot[]>([]);
//   const [loading, setLoading] = useState(true);

//   const fetchLabSlots = useCallback(async () => {
//     if (!labId) return;
    
//     setLoading(true);
//     try {
//       console.log("🔄 Fetching slots for labId:", labId);
//       const response: any = await http.get(`lab/LabSlot/lab/${labId}`);
      
//       const apiData: LabSlot[] = Array.isArray(response.data?.data) 
//         ? response.data.data 
//         : response.data || [];
      
//       console.log("📊 PROCESSED SLOTS:", apiData);
//       setAllSlots(apiData);
      
//     } catch (error) {
//       console.error("❌ Failed to fetch lab slots:", error);
//       setAllSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [labId]);

//   const filteredSlots = useMemo(() => {
//     if (!watchedDuration && !watchedStartTime && !watchedEndTime && !watchedStartDate && !watchedEndDate) {
//       return allSlots;
//     }

//     return allSlots.filter(slot => {
//       if (watchedDuration && slot.durationInMinutes !== Number(watchedDuration)) {
//         return false;
//       }
//       if (watchedStartTime && slot.startTime !== watchedStartTime) {
//         return false;
//       }
//       if (watchedEndTime && slot.endTime !== watchedEndTime) {
//         return false;
//       }
//       if (watchedStartDate && watchedEndDate) {
//         const slotDate = new Date(slot.sheduledDate);
//         const startDate = new Date(watchedStartDate);
//         const endDate = new Date(watchedEndDate);
//         if (slotDate < startDate || slotDate > endDate) {
//           return false;
//         }
//       }
//       return true;
//     });
//   }, [allSlots, watchedDuration, watchedStartTime, watchedEndTime, watchedStartDate, watchedEndDate]);

//   const handleCancel = () => {
//     reset();
//     setOpen(false);
//     setFormComponent(null);
//   };

//   const refetchSlots = () => {
//     fetchLabSlots();
//     handleCancel();
//   };

//   const clearFilters = () => {
//     reset({
//       labId: "",
//       durationInMinutes: "",
//       startTime: "",
//       endTime: "",
//       startDate: "",
//       endDate: "",
//       isAvailable: false,
//     });
//   };

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setLabId(userId || "");
//   }, []);

//   useEffect(() => {
//     if (labId) {
//       fetchLabSlots();
//     }
//   }, [labId, fetchLabSlots]);

//   useEffect(() => {
//     updateMainHeader("Schedules");
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([{ Schedules: "/lab-schedule" }]);

//   const handleClick = () => {
//     setFormComponent(
//       <SlotDrawer 
//         id="slotAdd"
//         control={control} 
//         reset={reset} 
//         setValue={setValue}
//         onCancel={handleCancel}
//         onSuccess={refetchSlots}
//       />
//     );
//     setOpen(true);
//   };

//   const getSlotsByPeriod = (period: 'morning' | 'afternoon' | 'evening') => {
//     return filteredSlots.filter(slot => {
//       if (!slot.startTime) return false;
//       const startHour = parseInt(slot.startTime.split(':')[0]);
//       if (period === 'morning') return startHour >= 6 && startHour < 12;
//       if (period === 'afternoon') return startHour >= 12 && startHour < 17;
//       return startHour >= 17;
//     });
//   };

//   const formatTime = (time: string) => {
//     if (!time) return "N/A";
//     const [hours, minutes] = time.split(':');
//     const hour = parseInt(hours);
//     const period = hour >= 12 ? 'PM' : 'AM';
//     const displayHour = hour % 12 || 12;
//     return `${displayHour}:${minutes} ${period}`;
//   };

//   const formatDate = (dateString: string) => {
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ height: '200px' }}>
//         <Typography>Loading schedule...</Typography>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container>
//         <Grid item xs={12}>
//           <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//             <Grid container alignItems="center" justifyContent="space-between">
//               <Grid item xs>
//                 <Typography variant="h6" fontWeight={600}>Schedule Management</Typography>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     Showing <strong>{filteredSlots.length}</strong> of <strong>{allSlots.length}</strong> total slots
//                   </Typography>
//                   {filteredSlots.length < allSlots.length && (
//                     <WSButton 
//                       label="Clear Filters" // ✅ FIXED: Use label prop
//                       size="small"
//                       onClick={clearFilters} // ✅ FIXED: Removed variant (uses default)
//                       sx={{
//                         textTransform: 'none',
//                         fontSize: '0.75rem',
//                         height: '28px !important'
//                       }} id={""}                    />
//                   )}
//                 </div>
//               </Grid>
//               <Grid item>
//                 <WSButton
//                   id="btnAddSlot"
//                   label="Add Slot"
//                   startIcon={<WSIcons.AddIcon />}
//                   onClick={handleClick}
//                   sx={{
//                     borderRadius: "999px",
//                     backgroundColor: "#098963!important",
//                     textTransform: "none",
//                     fontWeight: 500,
//                     height: "35px!important",
//                     fontSize: "0.875rem!important",
//                     px: 3,
//                     "&:hover": { backgroundColor: "#087654!important" },
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 1 }}>
//                 <CalendarTodayIcon /> Working Hours Filter
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <WSTimePicker 
//                     label="Start Time" 
//                     name="startTime" 
//                     id="startTime" 
//                     control={control} 
//                     rules={{ required: false }}
//                     timeSize="small" 
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <WSTimePicker 
//                     label="End Time" 
//                     name="endTime" 
//                     id="endTime" 
//                     control={control} 
//                     rules={{ required: false }}
//                     timeSize="small" 
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 1 }}>
//                 <FaRegClock /> Duration Filter
//               </Typography>
//               <WSTextField
//                 label="Minutes (e.g. 30)"
//                 id="durationInMinutes"
//                 name="durationInMinutes"
//                 control={control}
//                 rules={{ required: false }}
//               />
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 1 }}>
//                 <FaRegClock /> Date Range Filter
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}>
//                   <WSDateField
//                     id="startDate"
//                     name="startDate"
//                     label="From"
//                     dateFormat="DD-MM-YYYY"
//                     control={control}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <WSDateField
//                     id="endDate"
//                     name="endDate"
//                     label="To"
//                     dateFormat="DD-MM-YYYY"
//                     control={control}
//                     rules={{ required: false }}
//                   />
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>

//           {/* <Grid item xs={12} md={3}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 2 }}>
//                 Filters Active
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {watchedDuration && `Duration: ${watchedDuration}min `}
//                 {watchedStartTime && `Start: ${formatTime(watchedStartTime)} `}
//                 {watchedEndTime && `End: ${formatTime(watchedEndTime)}`}
//                 {watchedStartDate && watchedEndDate && `Date: ${watchedStartDate} to ${watchedEndDate}`}
//               </Typography>
//             </Paper>
//           </Grid> */}
//         </Grid>

//         <Grid container spacing={2} mt={2}>
//           {(['morning', 'afternoon', 'evening'] as const).map((period) => {
//             const periodSlots = getSlotsByPeriod(period);
//             return (
//               <Grid item xs={12} key={period}>
//                 <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight={600}
//                     sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     <GiDiamonds />
//                     {period.charAt(0).toUpperCase() + period.slice(1)} Slots ({periodSlots.length})
//                   </Typography>

//                   {periodSlots.length === 0 ? (
//                     <Typography variant="body2" color="text.secondary">
//                       No {period} slots matching current filters
//                     </Typography>
//                   ) : (
//                     <Box sx={{ maxHeight: 260, overflowY: "auto", pr: 1 }}>
//                       <Grid container spacing={2}>
//                         {periodSlots.map((slot, index) => (
//                           <Grid item xs={12} sm={6} md={3} key={slot.id || index}>
//                             <Paper sx={{ p: 1.5, backgroundColor: "#f5f5f5", borderRadius: "6px", height: "100%" }}>
//                               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                                 <Typography variant="body2" fontWeight={500}>
//                                   {formatDate(slot.sheduledDate)}
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   sx={{ color: slot.isAvailable ? "#4caf50" : "#f44336", fontWeight: 600 }}
//                                 >
//                                   {slot.isAvailable ? "Available" : "Unavailable"}
//                                 </Typography>
//                               </Box>
//                               <Typography variant="body1" fontWeight={600}>
//                                 {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 ({slot.durationInMinutes} min)
//                               </Typography>
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   )}
//                 </Paper>
//               </Grid>
//             );
//           })}
//         </Grid>

//         <SwipeableDrawerForm
//           anchor="right"
//           title="Add Slot"
//           openForm={open}
//           isEdit={false}
//           id="slotAdd"
//           formComponent={formComponent}
//           onClose={handleCancel}
//         />
//       </Grid>
//     </>
//   );
// });






// import { Box, Grid, Paper, Typography } from "@mui/material";
// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import { useForm } from "react-hook-form";
// import { FaRegClock } from "react-icons/fa6";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSDateField from "../../../Components/DateField/WSDateField";
// import { GiDiamonds } from "react-icons/gi";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import {
//   getLocalValue,
//   LoacalVariables,
//   updateMainHeader,
// } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SlotDrawer from "./Slote";
// import http from "../../../commonFunctions/httpClient";

// interface LabSlot {
//   id: string;
//   labId: string;
//   lab: any;
//   sheduledDate: string;
//   durationInMinutes: number;
//   startTime: string;
//   endTime: string;
//   isAvailable: boolean;
// }

// interface ScheduleFormData {
//   labId: string;
//   durationInMinutes: string;
//   selectedDate: string;
//   isAvailable: boolean;
// }

// export const ScheduleManagement: React.FC<any> = React.memo((props) => {
//   const methods = useForm<ScheduleFormData>({
//     defaultValues: {
//       labId: "",
//       durationInMinutes: "",
//       selectedDate: "",
//       isAvailable: false,
//     },
//   });

//   const { control, reset, setValue, watch } = methods;
  
//   const watchedDuration = watch("durationInMinutes");
//   const watchedSelectedDate = watch("selectedDate");

//   const [labId, setLabId] = useState<string>("");
//   const [open, setOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [allSlots, setAllSlots] = useState<LabSlot[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [currentDate, setCurrentDate] = useState<string>("");

//   const fetchLabSlots = useCallback(async (date?: string) => {
//     if (!labId) return;
    
//     setLoading(true);
//     try {
//       console.log("🔄 Fetching slots for labId:", labId, "date:", date || "today");
//       const apiDate = date || currentDate || new Date().toISOString().split('T')[0];
//       const response: any = await http.get(`lab/LabSlot/Lab/${labId}/date/${apiDate}`);
      
//       let apiData = [];
      
//       if (response.data?.data) {
//         apiData = response.data.data;
//       }
//       else if (response.data?.slots) {
//         apiData = response.data;
//       }
//       else if (response.slots) {
//         apiData = response;
//       }
//       else if (Array.isArray(response.data)) {
//         apiData = response.data;
//       }
//       else {
//         console.log("❌ Unknown structure, raw data:", response.data);
//         setAllSlots([]);
//         return;
//       }
      
//       const transformedSlots: LabSlot[] = [];
      
//       const transformSlot = (slot: any, period: string, scheduledDate: string): LabSlot => {
//         const calculateDuration = (start: string, end: string): number => {
//           const [startH, startM] = start.split(':').map(Number);
//           const [endH, endM] = end.split(':').map(Number);
//           const startMinutes = startH * 60 + startM;
//           const endMinutes = endH * 60 + endM;
//           return endMinutes - startMinutes;
//         };

//         return {
//           id: slot.id,
//           labId: labId,
//           lab: null,
//           sheduledDate: scheduledDate,
//           durationInMinutes: calculateDuration(slot.startTime, slot.endTime),
//           startTime: slot.startTime,
//           endTime: slot.endTime,
//           isAvailable: slot.isAvailable ?? true,
//         };
//       };

//       if (apiData.slots?.morning) {
//         apiData.slots.morning.forEach((slot: any) => {
//           transformedSlots.push(transformSlot(slot, 'morning', apiDate));
//         });
//       }
      
//       if (apiData.slots?.afternoon) {
//         apiData.slots.afternoon.forEach((slot: any) => {
//           transformedSlots.push(transformSlot(slot, 'afternoon', apiDate));
//         });
//       }
      
//       if (apiData.slots?.evening) {
//         apiData.slots.evening.forEach((slot: any) => {
//           transformedSlots.push(transformSlot(slot, 'evening', apiDate));
//         });
//       }

//       console.log("📊 TOTAL SLOTS COUNT:", transformedSlots.length);
//       setAllSlots(transformedSlots);
      
//     } catch (error) {
//       console.error("❌ Failed to fetch lab slots:", error);
//       setAllSlots([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [labId, currentDate]);

//   // ✅ FIXED: Date filter - Convert DD-MM-YYYY to YYYY-MM-DD for comparison
//   const filteredSlots = useMemo(() => {
//     // If no filters active, show all slots for current date
//     if (!watchedDuration && !watchedSelectedDate) {
//       return allSlots;
//     }

//     return allSlots.filter(slot => {
//       // Duration filter
//       if (watchedDuration && slot.durationInMinutes !== Number(watchedDuration)) {
//         return false;
//       }
      
//       // ✅ FIXED DATE FILTER
//       if (watchedSelectedDate) {
//         try {
//           // Parse DD-MM-YYYY format from WSDateField (e.g., "09-02-2026")
//           const [day, month, year] = watchedSelectedDate.split('-');
//           const filterDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`; // YYYY-MM-DD
          
//           // Compare with slot date (already YYYY-MM-DD from API)
//           const slotDateStr = slot.sheduledDate;
          
//           console.log("🔍 Filter date:", filterDateStr, "Slot date:", slotDateStr);
          
//           if (slotDateStr !== filterDateStr) {
//             return false;
//           }
//         } catch (error) {
//           console.error("❌ Date filter error:", error, "Input:", watchedSelectedDate);
//           return false;
//         }
//       }
      
//       return true;
//     });
//   }, [allSlots, watchedDuration, watchedSelectedDate]);

//   const handleCancel = () => {
//     reset();
//     setOpen(false);
//     setFormComponent(null);
//   };

//   const refetchSlots = () => {
//     fetchLabSlots(currentDate);
//     handleCancel();
//   };

//   const clearFilters = () => {
//     reset({
//       labId: "",
//       durationInMinutes: "",
//       selectedDate: "",
//       isAvailable: false,
//     });
//     fetchLabSlots(currentDate); // ✅ Refetch current date
//   };

//   // ✅ NEW: Auto-fetch when date filter changes
//   useEffect(() => {
//     if (watchedSelectedDate && labId) {
//       try {
//         const [day, month, year] = watchedSelectedDate.split('-');
//         const apiDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
//         console.log("📅 Date filter changed, fetching slots for:", apiDate);
//         fetchLabSlots(apiDate);
//       } catch (error) {
//         console.error("Date conversion error:", error);
//       }
//     }
//   }, [watchedSelectedDate, labId, fetchLabSlots]);

//   useEffect(() => {
//     const today = new Date().toISOString().split('T')[0];
//     setCurrentDate(today);
//     console.log("📅 Current date set to:", today);
//   }, []);

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setLabId(userId || "");
//   }, []);

//   useEffect(() => {
//     if (labId && currentDate) {
//       fetchLabSlots(currentDate);
//     }
//   }, [labId, currentDate, fetchLabSlots]);

//   useEffect(() => {
//     updateMainHeader("Schedules");
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([{ Schedules: "/lab-schedule" }]);

//   const handleClick = () => {
//     setFormComponent(
//       <SlotDrawer 
//         id="slotAdd"
//         control={control} 
//         reset={reset} 
//         setValue={setValue}
//         onCancel={handleCancel}
//         onSuccess={refetchSlots}
//       />
//     );
//     setOpen(true);
//   };

//   const getSlotsByPeriod = (period: 'morning' | 'afternoon' | 'evening') => {
//     return filteredSlots.filter(slot => {
//       if (!slot.startTime) return false;
//       const startHour = parseInt(slot.startTime.split(':')[0]);
//       if (period === 'morning') return startHour >= 6 && startHour < 12;
//       if (period === 'afternoon') return startHour >= 12 && startHour < 17;
//       return startHour >= 17;
//     });
//   };

//   const formatTime = (time: string) => {
//     if (!time) return "N/A";
//     const [hours, minutes] = time.split(':');
//     const hour = parseInt(hours);
//     const period = hour >= 12 ? 'PM' : 'AM';
//     const displayHour = hour % 12 || 12;
//     return `${displayHour}:${minutes} ${period}`;
//   };

//   const formatDate = (dateString: string) => {
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ height: '200px' }}>
//         <Typography>Loading schedule for {currentDate}...</Typography>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container>
//         <Grid item xs={12}>
//           <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
//             <Grid container alignItems="center" justifyContent="space-between">
//               <Grid item xs>
//                 <Typography variant="h6" fontWeight={600}>Schedule Management</Typography>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                   <Typography variant="body2" color="text.secondary">
//                     <strong>{formatDate(currentDate)}</strong> • 
//                     Showing <strong>{filteredSlots.length}</strong> of <strong>{allSlots.length}</strong> total slots
//                   </Typography>
//                   {filteredSlots.length < allSlots.length && (
//                     <WSButton 
//                       label="Clear Filters"
//                       size="small"
//                       onClick={clearFilters}
//                       sx={{
//                         textTransform: 'none',
//                         fontSize: '0.75rem',
//                         height: '28px !important'
//                       }} 
//                       id={""} 
//                     />
//                   )}
//                 </div>
//               </Grid>
//               <Grid item>
//                 <WSButton
//                   id="btnAddSlot"
//                   label="Add Slot"
//                   startIcon={<WSIcons.AddIcon />}
//                   onClick={handleClick}
//                   sx={{
//                     borderRadius: "999px",
//                     backgroundColor: "#098963!important",
//                     textTransform: "none",
//                     fontWeight: 500,
//                     height: "35px!important",
//                     fontSize: "0.875rem!important",
//                     px: 3,
//                     "&:hover": { backgroundColor: "#087654!important" },
//                   }}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* ✅ ONLY 2 FILTERS: Duration + Date */}
//         <Grid container spacing={2} mt={2}>
//           <Grid item xs={12} md={6}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 1 }}>
//                 <FaRegClock /> Duration Filter
//               </Typography>
//               <WSTextField
//                 label="Minutes (e.g. 30)"
//                 id="durationInMinutes"
//                 name="durationInMinutes"
//                 control={control}
//                 rules={{ required: false }}
//               />
//             </Paper>
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
//               <Typography sx={{ fontSize: "1rem", mb: 1 }}>
//                 <CalendarTodayIcon /> Date Filter
//               </Typography>
//               <WSDateField
//                 id="selectedDate"
//                 name="selectedDate"
//                 label="Select Date"
//                 dateFormat="DD-MM-YYYY"
//                 control={control}
//                 rules={{ required: false }}
//               />
//             </Paper>
//           </Grid>
//         </Grid>

//         <Grid container spacing={2} mt={2}>
//           {(['morning', 'afternoon', 'evening'] as const).map((period) => {
//             const periodSlots = getSlotsByPeriod(period);
//             return (
//               <Grid item xs={12} key={period}>
//                 <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px" }}>
//                   <Typography
//                     variant="subtitle1"
//                     fontWeight={600}
//                     sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
//                   >
//                     <GiDiamonds />
//                     {period.charAt(0).toUpperCase() + period.slice(1)} Slots ({periodSlots.length})
//                   </Typography>

//                   {periodSlots.length === 0 ? (
//                     <Typography variant="body2" color="text.secondary">
//                       No {period} slots matching current filters
//                     </Typography>
//                   ) : (
//                     <Box sx={{ maxHeight: 260, overflowY: "auto", pr: 1 }}>
//                       <Grid container spacing={2}>
//                         {periodSlots.map((slot, index) => (
//                           <Grid item xs={12} sm={6} md={3} key={slot.id || index}>
//                             <Paper sx={{ p: 1.5, backgroundColor: "#f5f5f5", borderRadius: "6px", height: "100%" }}>
//                               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                                 <Typography variant="body2" fontWeight={500}>
//                                   {formatDate(slot.sheduledDate)}
//                                 </Typography>
//                                 <Typography
//                                   variant="caption"
//                                   sx={{ color: slot.isAvailable ? "#4caf50" : "#f44336", fontWeight: 600 }}
//                                 >
//                                   {slot.isAvailable ? "Available" : "Unavailable"}
//                                 </Typography>
//                               </Box>
//                               <Typography variant="body1" fontWeight={600}>
//                                 {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
//                               </Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 ({slot.durationInMinutes} min)
//                               </Typography>
//                             </Paper>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </Box>
//                   )}
//                 </Paper>
//               </Grid>
//             );
//           })}
//         </Grid>

//         <SwipeableDrawerForm
//           anchor="right"
//           title="Add Slot"
//           openForm={open}
//           isEdit={false}
//           id="slotAdd"
//           formComponent={formComponent}
//           onClose={handleCancel}
//         />
//       </Grid>
//     </>
//   );
// });






import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import WSButton from "../../../Components/Button/WSButton";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useForm } from "react-hook-form";
import { FaRegClock } from "react-icons/fa6";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSDateField from "../../../Components/DateField/WSDateField";
import { GiDiamonds } from "react-icons/gi";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  getLocalValue,
  LoacalVariables,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import SlotDrawer from "./Slote";
import http from "../../../commonFunctions/httpClient";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import dayjs from "dayjs";

// The date filter holds "DD-MM-YYYY"; the API wants "YYYY-MM-DD". Both use the local calendar day.
const todayFilterValue = () => dayjs().format("DD-MM-YYYY");
const toApiDate = (filterValue?: string) => {
  const [day, month, year] = (filterValue || "").split("-");
  return day && month && year ? `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}` : "";
};

interface LabSlot {
  id: string;
  labId: string;
  lab: any;
  sheduledDate: string;
  durationInMinutes: number;
  startTime: string;
  endTime: string;
  isAvailable: boolean;
}

interface ScheduleFormData {
  labId: string;
  durationInMinutes: string;
  selectedDate: string;
  isAvailable: boolean;
}

export const ScheduleManagement: React.FC<any> = React.memo((props) => {
  const methods = useForm<ScheduleFormData>({
    defaultValues: {
      labId: "",
      durationInMinutes: "",
      // Opens on today's slots
      selectedDate: todayFilterValue(),
      isAvailable: false,
    },
  });

  const { control, reset, setValue, watch, getValues } = methods;
  
  const watchedDuration = watch("durationInMinutes");
  const watchedSelectedDate = watch("selectedDate");

  const [labId, setLabId] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [formComponent, setFormComponent] = useState<any>();
  const [allSlots, setAllSlots] = useState<LabSlot[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState<string>(() => dayjs().format("YYYY-MM-DD"));

  const fetchLabSlots = useCallback(async (date?: string) => {
    if (!labId) return;
    
    setLoading(true);
    try {
      console.log("🔄 Fetching slots for labId:", labId, "date:", date || "today");
      const apiDate = date || currentDate || dayjs().format("YYYY-MM-DD");
      const response: any = await http.get(`lab/LabSlot/Lab/${labId}/date/${apiDate}`);
      
      let apiData = [];
      
      if (response.data?.data) {
        apiData = response.data.data;
      }
      else if (response.data?.slots) {
        apiData = response.data;
      }
      else if (response.slots) {
        apiData = response;
      }
      else if (Array.isArray(response.data)) {
        apiData = response.data;
      }
      else {
        console.log("❌ Unknown structure, raw data:", response.data);
        setAllSlots([]);
        return;
      }
      
      const transformedSlots: LabSlot[] = [];
      
      const transformSlot = (slot: any, period: string, scheduledDate: string): LabSlot => {
        const calculateDuration = (start: string, end: string): number => {
          const [startH, startM] = start.split(':').map(Number);
          const [endH, endM] = end.split(':').map(Number);
          const startMinutes = startH * 60 + startM;
          const endMinutes = endH * 60 + endM;
          return endMinutes - startMinutes;
        };

        return {
          id: slot.id,
          labId: labId,
          lab: null,
          sheduledDate: scheduledDate,
          durationInMinutes: calculateDuration(slot.startTime, slot.endTime),
          startTime: slot.startTime,
          endTime: slot.endTime,
          isAvailable: slot.isAvailable ?? true,
        };
      };

      if (apiData.slots?.morning) {
        apiData.slots.morning.forEach((slot: any) => {
          transformedSlots.push(transformSlot(slot, 'morning', apiDate));
        });
      }
      
      if (apiData.slots?.afternoon) {
        apiData.slots.afternoon.forEach((slot: any) => {
          transformedSlots.push(transformSlot(slot, 'afternoon', apiDate));
        });
      }
      
      if (apiData.slots?.evening) {
        apiData.slots.evening.forEach((slot: any) => {
          transformedSlots.push(transformSlot(slot, 'evening', apiDate));
        });
      }

      console.log("📊 TOTAL SLOTS COUNT:", transformedSlots.length);
      setAllSlots(transformedSlots);
      
    } catch (error) {
      console.error("❌ Failed to fetch lab slots:", error);
      setAllSlots([]);
    } finally {
      setLoading(false);
    }
  }, [labId, currentDate]);

  // ✅ FIXED: Date filter - Convert DD-MM-YYYY to YYYY-MM-DD for comparison
 const filteredSlots = useMemo(() => {
  console.log("🔍 Filtering slots:", {
    allSlotsCount: allSlots.length,
    watchedDuration,
    watchedSelectedDate,
    slots: allSlots.slice(0, 3) // First 3 for debugging
  });

  // ✅ FIXED: Always filter when ANY filter is active
  return allSlots.filter(slot => {
    let passes = true;

    // Duration filter - ONLY apply if duration is entered
    if (watchedDuration && watchedDuration.trim() !== "") {
      const durationNum = Number(watchedDuration);
      if (isNaN(durationNum) || slot.durationInMinutes !== durationNum) {
        console.log(`❌ Slot ${slot.id} failed duration filter: ${slot.durationInMinutes} !== ${durationNum}`);
        passes = false;
      }
    }

    // Date filter - ONLY apply if date is selected
    if (watchedSelectedDate && watchedSelectedDate.trim() !== "") {
      try {
        const [day, month, year] = watchedSelectedDate.split('-');
        const filterDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        if (slot.sheduledDate !== filterDateStr) {
          console.log(`❌ Slot ${slot.id} failed date filter: ${slot.sheduledDate} !== ${filterDateStr}`);
          passes = false;
        }
      } catch (error) {
        console.error("❌ Date filter error:", error);
        passes = false;
      }
    }

    return passes;
  });
}, [allSlots, watchedDuration, watchedSelectedDate]);


  // Day being shown: the selected date, or today when the date filter is empty
  const viewDate = toApiDate(watchedSelectedDate) || currentDate;

  const handleCancel = () => {
    // Clear the Add Slot fields but stay on the day being viewed
    reset({ labId: "", durationInMinutes: "", selectedDate: getValues("selectedDate") || todayFilterValue(), isAvailable: false });
    setOpen(false);
    setFormComponent(null);
  };

  const refetchSlots = () => {
    fetchLabSlots(viewDate);
    handleCancel();
  };

  // Re-check every minute so slots that have just passed turn grey without a reload
  const [now, setNow] = useState(() => dayjs());
  useEffect(() => {
    const timer = setInterval(() => setNow(dayjs()), 60000);
    return () => clearInterval(timer);
  }, []);

  // Marking slots available / unavailable: select slots, then use the action bar
  const { showMessage } = useSnackbar();
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  const [updating, setUpdating] = useState(false);

  // Selection belongs to the day being shown
  useEffect(() => {
    setSelectedIds(new Set());
  }, [viewDate]);

  const toggleSelected = (id: string) =>
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });

  // A slot that has already started can't be changed
  const isSelectable = (slot: LabSlot) => !!slot.id && !isPastSlot(slot);

  const selectedSlots = allSlots.filter((slot) => selectedIds.has(slot.id));
  const slotsToMakeUnavailable = selectedSlots.filter((slot) => slot.isAvailable);
  const slotsToMakeAvailable = selectedSlots.filter((slot) => !slot.isAvailable);

  // One slot: PATCH lab/LabSlot/{slotId}/status?isActive=...
  // Several slots: PATCH lab/LabSlot/bulk/status with { slotIds, isActive }
  const applySlotStatus = async (isActive: boolean) => {
    const targets = (isActive ? slotsToMakeAvailable : slotsToMakeUnavailable).map((slot) => slot.id);
    if (targets.length === 0) return;
    setUpdating(true);
    try {
      const response: any =
        targets.length === 1
          ? await http.patch<any>(`lab/LabSlot/${targets[0]}/status`, null, { params: { isActive } })
          : await http.patch<any>("lab/LabSlot/bulk/status", { slotIds: targets, isActive });
      if (response?.success === false) {
        throw new Error(response?.message || "Failed to update the slots");
      }
      // Show the change right away, then sync with the server
      setAllSlots((prev) => prev.map((slot) => (targets.includes(slot.id) ? { ...slot, isAvailable: isActive } : slot)));
      setSelectedIds(new Set());
      showMessage(
        `${targets.length} slot${targets.length === 1 ? "" : "s"} marked ${isActive ? "available" : "unavailable"}`,
        "success"
      );
      fetchLabSlots(viewDate);
    } catch (error: any) {
      console.error("Slot status update failed:", error);
      const data = error?.response?.data;
      showMessage((typeof data === "string" ? data : data?.message) || error?.message || "Failed to update the slots", "error");
    } finally {
      setUpdating(false);
    }
  };

  const clearFilters = () => {
    reset({
      labId: "",
      durationInMinutes: "",
      selectedDate: todayFilterValue(),
      isAvailable: false,
    });
  };

  // Today's local date (not UTC, which is a day behind before 5:30 AM IST)
  useEffect(() => {
    setCurrentDate(dayjs().format("YYYY-MM-DD"));
  }, []);

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setLabId(userId || "");
  }, []);

  // Load slots for the day being viewed (today by default)
  useEffect(() => {
    if (labId && viewDate) {
      fetchLabSlots(viewDate);
    }
    // fetchLabSlots changes with currentDate; viewDate already covers that
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labId, viewDate]);

  useEffect(() => {
    updateMainHeader("Schedules");
  }, []);

  breadCrumbsStore.updateBreadCrumbs([{ Schedules: "/lab-schedule" }]);

  const handleClick = () => {
    setFormComponent(
      <SlotDrawer 
        id="slotAdd"
        onCancel={handleCancel}
        onSuccess={refetchSlots}
      />
    );
    setOpen(true);
  };

  const getSlotsByPeriod = (period: 'morning' | 'afternoon' | 'evening') => {
    return filteredSlots.filter(slot => {
      if (!slot.startTime) return false;
      const startHour = parseInt(slot.startTime.split(':')[0]);
      if (period === 'morning') return startHour >= 6 && startHour < 12;
      if (period === 'afternoon') return startHour >= 12 && startHour < 17;
      return startHour >= 17;
    });
  };

  const formatTime = (time: string) => {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${period}`;
  };

  // "05:20 PM": two-digit hour, as in the mobile app
  const formatChipTime = (time: string) => {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    return `${String(hour % 12 || 12).padStart(2, '0')}:${minutes} ${hour >= 12 ? 'PM' : 'AM'}`;
  };

  // Slot start is before now (earlier today or an earlier day)
  const isPastSlot = (slot: LabSlot) =>
    !!slot.startTime && dayjs(`${slot.sheduledDate}T${slot.startTime}`).isBefore(now);

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  if (loading) {
    return (
      <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ height: '200px' }}>
        <Typography>Loading schedule for {formatDate(viewDate)}...</Typography>
      </Grid>
    );
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px" }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs>
                <Typography variant="h6" fontWeight={600}>Schedule Management</Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>{formatDate(viewDate)}</strong> • 
                    Showing <strong>{filteredSlots.length}</strong> of <strong>{allSlots.length}</strong> total slots
                  </Typography>
                  {filteredSlots.length < allSlots.length && (
                    <WSButton 
                      label="Clear Filters"
                      size="small"
                      onClick={clearFilters}
                      sx={{
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        height: '28px !important'
                      }} 
                      id={""} 
                    />
                  )}
                </div>
              </Grid>
              <Grid item>
                <WSButton
                  id="btnAddSlot"
                  label="Add Slot"
                  startIcon={<WSIcons.AddIcon />}
                  onClick={handleClick}
                  sx={{
                    borderRadius: "999px",
                    backgroundColor: "#098963!important",
                    textTransform: "none",
                    fontWeight: 500,
                    height: "35px!important",
                    fontSize: "0.875rem!important",
                    px: 3,
                    "&:hover": { backgroundColor: "#087654!important" },
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* ✅ ONLY 2 FILTERS: Duration + Date */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
              <Typography sx={{ fontSize: "1rem", mb: 1 }}>
                <FaRegClock /> Duration Filter
              </Typography>
              <WSTextField
                label="Minutes (e.g. 30)"
                id="durationInMinutes"
                name="durationInMinutes"
                control={control}
                rules={{ required: false }}
              />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ px: 2.5, pb: 3, borderRadius: "8px", height: "100%" }}>
              <Typography sx={{ fontSize: "1rem", mb: 1 }}>
                <CalendarTodayIcon /> Date Filter
              </Typography>
              <WSDateField
                id="selectedDate"
                name="selectedDate"
                label="Select Date"
                dateFormat="DD-MM-YYYY"
                control={control}
                rules={{ required: false }}
              />
            </Paper>
          </Grid>
        </Grid>

        {/* Legend */}
        <Box sx={{ display: "flex", gap: 2.5, mt: 2, px: 0.5, flexWrap: "wrap" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Box sx={{ width: 12, height: 12, borderRadius: "3px", bgcolor: "#CDEBE2" }} />
            <Typography variant="caption" color="text.secondary">Available</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Box sx={{ width: 12, height: 12, borderRadius: "3px", bgcolor: "#E6E6E1" }} />
            <Typography variant="caption" color="text.secondary">Past or unavailable</Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            Select upcoming slots to mark them available or unavailable
          </Typography>
        </Box>

        {/* Action bar: appears once slots are selected */}
        {selectedSlots.length > 0 && (
          <Paper
            elevation={0}
            role="region"
            aria-label="Change selected slots"
            sx={{
              mt: 1.5,
              px: 2,
              py: 1.25,
              borderRadius: "12px",
              border: "1px solid #098963",
              bgcolor: "#F3FBF8",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flexWrap: "wrap",
            }}
          >
            <Typography sx={{ fontWeight: 600, mr: "auto" }}>{selectedSlots.length} selected</Typography>
            <Button
              variant="outlined"
              disabled={updating || slotsToMakeUnavailable.length === 0}
              onClick={() => applySlotStatus(false)}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px", color: "#B26A00", borderColor: "#B26A00" }}
            >
              Mark unavailable ({slotsToMakeUnavailable.length})
            </Button>
            <Button
              variant="contained"
              disableElevation
              disabled={updating || slotsToMakeAvailable.length === 0}
              onClick={() => applySlotStatus(true)}
              startIcon={updating ? <CircularProgress size={16} color="inherit" /> : undefined}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px", bgcolor: "#098963", "&:hover": { bgcolor: "#077352" } }}
            >
              Mark available ({slotsToMakeAvailable.length})
            </Button>
            <Button
              disabled={updating}
              onClick={() => setSelectedIds(new Set())}
              sx={{ textTransform: "none", color: "#828584" }}
            >
              Clear
            </Button>
          </Paper>
        )}

        <Grid container spacing={2} mt={0}>
          {(['morning', 'afternoon', 'evening'] as const).map((period) => {
            const periodSlots = getSlotsByPeriod(period);
            return (
              <Grid item xs={12} key={period}>
                <Paper elevation={0} sx={{ borderRadius: "16px", border: "1px solid #DDEFE8", overflow: "hidden" }}>
                  {/* Header: period and slot count */}
                  <Box
                    sx={{
                      px: 2.5,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      borderBottom: "1px solid #E5F2EC",
                    }}
                  >
                    <GiDiamonds />
                    <Typography component="h3" fontWeight={600}>
                      {period.charAt(0).toUpperCase() + period.slice(1)}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#098963", fontWeight: 700 }}>
                      {periodSlots.length} Slot
                    </Typography>
                    {periodSlots.some(isSelectable) && (
                      <Button
                        size="small"
                        onClick={() => {
                          const ids = periodSlots.filter(isSelectable).map((slot) => slot.id);
                          const allSelected = ids.every((id) => selectedIds.has(id));
                          setSelectedIds((prev) => {
                            const next = new Set(prev);
                            ids.forEach((id) => (allSelected ? next.delete(id) : next.add(id)));
                            return next;
                          });
                        }}
                        sx={{ ml: "auto", textTransform: "none", fontWeight: 600, color: "#098963" }}
                      >
                        {periodSlots.filter(isSelectable).every((slot) => selectedIds.has(slot.id)) ? "Unselect all" : "Select all"}
                      </Button>
                    )}
                  </Box>

                  <Box sx={{ p: 2 }}>
                    {periodSlots.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">
                        No {period} slots matching current filters
                      </Typography>
                    ) : (
                      <Box
                        component="ul"
                        sx={{
                          listStyle: "none",
                          m: 0,
                          p: 0,
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "repeat(4, 1fr)",
                            sm: "repeat(6, 1fr)",
                            md: "repeat(8, 1fr)",
                            lg: "repeat(10, 1fr)",
                          },
                          gap: 1.25,
                        }}
                      >
                        {periodSlots.map((slot, index) => {
                          const past = isPastSlot(slot);
                          const grey = !slot.isAvailable || past;
                          const selectable = isSelectable(slot);
                          const selected = selectedIds.has(slot.id);
                          return (
                            <li key={slot.id || index} style={{ display: "block" }}>
                              <ButtonBase
                                role="checkbox"
                                aria-checked={selected}
                                aria-label={`${formatChipTime(slot.startTime)}, ${
                                  past ? "past" : slot.isAvailable ? "available" : "unavailable"
                                }${selected ? ", selected" : ""}`}
                                disabled={!selectable}
                                onClick={() => toggleSelected(slot.id)}
                                title={`${formatTime(slot.startTime)} - ${formatTime(slot.endTime)} (${slot.durationInMinutes} min)`}
                                sx={{
                                  width: "100%",
                                  py: 1.5,
                                  borderRadius: "8px",
                                  fontWeight: 600,
                                  fontSize: "0.85rem",
                                  bgcolor: grey ? "#E6E6E1" : "#CDEBE2",
                                  color: grey ? "#6B6B6B" : "#098963",
                                  boxShadow: selected ? "inset 0 0 0 2px #098963" : "none",
                                  "&:hover": selectable ? { boxShadow: "inset 0 0 0 2px #098963" } : undefined,
                                  "&.Mui-disabled": { opacity: 1, cursor: "default" },
                                  "&.Mui-focusVisible": { outline: "2px solid #022219" },
                                }}
                              >
                                {formatChipTime(slot.startTime)}
                              </ButtonBase>
                            </li>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>

        <SwipeableDrawerForm
          anchor="right"
          title="Add Slot"
          openForm={open}
          isEdit={false}
          id="slotAdd"
          formComponent={formComponent}
          onClose={handleCancel}
        />
      </Grid>
    </>
  );
});
